import React from 'react';
import { ZendeskHelpCenterUrlList } from './ZendeskHelpCenterUrlList';

export const ZendeskHelpCenterAddUrls = ({
  control,
  clearErrors = (..._args: any[]) => {},
}: {
  control?: any;
  clearErrors?: (...args: any[]) => void;
}) => (
  <ZendeskHelpCenterUrlList
    control={control}
    clearErrors={clearErrors}
    name={'source_links'}
    title={'Added URLs'}
    itemLabel={'added URL'}
    addLabel={'Add specific articles'}
  />
);
